import { styled } from '@mui/material/styles';

export const SceneIcon = styled('div')(({ theme }) => ({
  '.MuiSvgIcon-root': {
    display: 'block',
    fontSize: '4rem',
  },
  marginBottom: theme.spacing(2),
}));
